import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-default',
  templateUrl: './button-default.component.html',
})
export class ButtonDefaultComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
